import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bcc5b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-recipe-details" }
const _hoisted_2 = { class: "container-recipe-tags-modify" }
const _hoisted_3 = { class: "container-recipe-header" }
const _hoisted_4 = { class: "container-tags-favourite" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "container-recipe-user-card" }
const _hoisted_7 = {
  key: 0,
  class: "container-controls"
}
const _hoisted_8 = { class: "container-recipe-title-time" }
const _hoisted_9 = { class: "container-time" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "container-recipe-element" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Ingredients", -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "container-recipe-element" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Method", -1))
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "container-recipe-bottom" }
const _hoisted_20 = {
  key: 0,
  class: "container-recipe-image-carousel"
}
const _hoisted_21 = { class: "container-recipe-comments" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_EyeOffIcon = _resolveComponent("EyeOffIcon")!
  const _component_TagsContainer = _resolveComponent("TagsContainer")!
  const _component_StarSolidIcon = _resolveComponent("StarSolidIcon")!
  const _component_StarOutlineIcon = _resolveComponent("StarOutlineIcon")!
  const _component_UserIconName = _resolveComponent("UserIconName")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PencilAltIcon = _resolveComponent("PencilAltIcon")!
  const _component_ArchiveIcon = _resolveComponent("ArchiveIcon")!
  const _component_UsersIcon = _resolveComponent("UsersIcon")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_RecipeCommentService = _resolveComponent("RecipeCommentService")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, { "header-text": "" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.recipe.isPrivate)
          ? (_openBlock(), _createBlock(_component_EyeOffIcon, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TagsContainer, { tags: _ctx.tags }, null, 8, ["tags"]),
          (_ctx.recipe.authorId !== _ctx.contextUser._id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.favourite)
                  ? (_openBlock(), _createBlock(_component_StarSolidIcon, {
                      key: 0,
                      onClick: _ctx.unFavouriteRecipe
                    }, null, 8, ["onClick"]))
                  : (!_ctx.favourite)
                    ? (_openBlock(), _createBlock(_component_StarOutlineIcon, {
                        key: 1,
                        onClick: _ctx.favouriteRecipe
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: `/Friend/${_ctx.authorUser._id}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UserIconName, {
                "profile-picture": _ctx.authorUser.profilePicture,
                name: _ctx.authorUser.displayName,
                "image-dimensions": 30,
                "font-size": 1,
                padding: 15
              }, null, 8, ["profile-picture", "name"])
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      (_ctx.recipe.authorId === _ctx.contextUser._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: `/Recipe/Modify/${_ctx.recipe._id}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PencilAltIcon)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_ArchiveIcon, { onClick: _ctx.archiveRecipe }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.recipe.title), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "time-icons",
            src: require('@/assets/chopping-board.png')
          }, null, 8, _hoisted_10),
          _createElementVNode("h3", null, _toDisplayString(_ctx.recipe.prepTime) + " mins", 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "time-icons",
            src: require('@/assets/cooking-time.png')
          }, null, 8, _hoisted_11),
          _createElementVNode("h3", null, _toDisplayString(_ctx.recipe.cookTime) + " mins", 1)
        ]),
        (_ctx.recipe?.servings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_UsersIcon),
              _createElementVNode("h3", null, _toDisplayString(_ctx.recipe.servings), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", {
        innerHTML: _ctx.recipe.ingredients
      }, null, 8, _hoisted_15)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", {
        innerHTML: _ctx.recipe.method
      }, null, 8, _hoisted_18)
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.recipe.images.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_Carousel, {
              slides: _ctx.recipe.images.sort((a, b) => a.index - b.index),
              interval: 3000,
              controls: _ctx.recipe.images.length > 1,
              indicators: _ctx.recipe.images.length > 1
            }, null, 8, ["slides", "controls", "indicators"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_RecipeCommentService, { recipe: _ctx.recipe }, null, 8, ["recipe"])
      ])
    ])
  ]))
}